export const scope =
  'profile email offline_access read:authenticators remove:authenticators' // add `enroll` scope to request access to create 2FA authenticators
